import { Component, OnInit,Input } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-coin-purchase',
  templateUrl: './coin-purchase.component.html',
  styleUrls: ['./coin-purchase.component.scss'],
})
export class CoinPurchaseComponent implements OnInit {
  @Input() isAuthenticated: boolean = false;
  @Input() chips: number;
  @Input() points: number;
  @Input() credits: number;
  @Input() price: number;
  @Input() showTitle = false;
  @Input() tag: string;
  @Input() imageName: string;
  @Input() bonusPurchase =false;
  @Input() priceCode = ""
  private itemInfo:any;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";

  constructor(private config: ConfigService) { }

  ngOnInit() {
    this.itemInfo={
    priceCode:this.priceCode,
    credits:this.credits,
    chips:this.chips,
    points:this.points,
    price:this.price,
    isAuthenticated:this.isAuthenticated
    }
  
  }
  isTagMatch(tagValue: string, expectedValue: string): boolean {
    return tagValue === expectedValue;
  }
  
  

}
